module.exports = require('./_global');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_path.js
// module id = 125
// module chunks = 0